import React from "react";
import Icon, { IconProps } from "./Icon";
import { vars } from "@puzzle/theme";

export default function NavChecklist({
  viewBox = "0 0 24 24",
  width = 24,
  height = 24,
  color = vars.colors["text-neutral-base"],
  ...iconProps
}: IconProps) {
  return (
    <Icon viewBox={viewBox} width={width} height={height} {...iconProps} fill="none" stroke="none">
      <path
        d="M20 12H16.8L14.4 17L9.6 7L7.2 12H4"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="4"
        y="4"
        width="16"
        height="16"
        rx="4"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
